module.exports = __webpack_public_path__ + "img/align-1.c0b3072f.svg";